import request from '../../libs/request';

export default {
  getCategories: (siteId) => request(`api/v1/site/${siteId}/map/category`).get(),
  getBrands: (queryParams = null, siteId) => request(`api/v2/${siteId}/marca/find`).get({ queryParams }),
};
